import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

interface EmptyPositionProps {
  type:
    | 'position'
    | 'order'
    | 'positionHistory'
    | 'tradeHistory'
    | 'orderHistory'
    | 'transactionHistory';
}

const EmptyPosition: React.FC<EmptyPositionProps> = ({ type }) => {
  const { t } = useTranslation();

  const config = {
    // 보유포지션
    position: {
      icon: '📊',
      title: t('noPositions'),
      desc: t('noPositionsDesc'),
    },
    // 미체결주문
    order: {
      icon: '📋',
      title: t('noOrders'),
      desc: t('noOrdersDesc'),
    },
    // 완료포지션
    positionHistory: {
      icon: '📋',
      title: t('noPositionsHistory'),
      desc: t('noPositionsHistoryDesc'),
    },
    // 체결내역
    tradeHistory: {
      icon: '📋',
      title: t('noFilledHistory'),
      desc: t('noFilledHistoryDesc'),
    },
    // 주문내역
    orderHistory: {
      icon: '📋',
      title: t('noOrderHistory'),
      desc: t('noOrderHistoryDesc'),
    },
    // 거래내역
    transactionHistory: {
      icon: '📋',
      title: t('noTradeHistory'),
      desc: t('noTradeHistoryDesc'),
    },
  };

  const { icon, title, desc } = config[type];

  return (
    <EmptyContainer>
      <EmptyIcon>{icon}</EmptyIcon>
      <EmptyTitle>{title}</EmptyTitle>
      <EmptyDesc>{desc}</EmptyDesc>
    </EmptyContainer>
  );
};

export default EmptyPosition;

const EmptyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  background: transparent;
  border-radius: 8px;
`;

const EmptyIcon = styled.div`
  font-size: 40px;
  margin-bottom: 12px;
  opacity: 0.6;
`;

const EmptyTitle = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 6px;
  font-family: 'NanumSquareRound', sans-serif;
`;

const EmptyDesc = styled.div`
  font-size: 13px;
  color: #777986;
  text-align: center;
  font-family: 'NanumSquareRound', sans-serif;
`;
